'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const TShirtNumberIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.9601 11.86C10.9601 11.86 12.4701 11.86 13.4601 11.86V21M9.72005 2.76C9.72005 4 10.7201 5 11.9601 5C13.2001 5 14.2001 4 14.2001 2.76M10.9601 21.25H7.06005C6.51005 21.25 6.06005 20.8 6.06005 20.25V11.69C5.09005 11.43 4.09005 11.16 3.16005 10.91C2.84005 10.83 2.67005 10.49 2.78005 10.19C3.44005 8.36 4.19005 6.31 4.78005 4.69C6.27005 4 7.77005 3.3 8.94005 2.75H14.9601C16.1301 3.3 17.6301 3.99 19.1201 4.69C19.3201 5.24 20.1501 7.54 20.6801 9C20.9001 9.61 21.0701 10.07 21.1101 10.19M20.2701 18.28V13.87C20.2701 12.63 19.2601 11.62 18.0201 11.62C16.7801 11.62 15.7701 12.63 15.7701 13.87V18.28C15.7701 19.52 16.7801 20.53 18.0201 20.53C19.2601 20.53 20.2701 19.52 20.2701 18.28Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpTShirtNumberIcon = forwardRef(TShirtNumberIcon);

export { VpTShirtNumberIcon as default };
